import styled from 'styled-components'

export const DropDownGalleryContainer = styled.div`
    display: flex;
    border-radius: 3px;
    border: 1px solid var(--blue-500);
    width: 100px;
    height: 24px;

    .ellipsisGallery,
    .btn-default {
        padding-bottom: 8px;
    }

    ul {
        border-radius: 4px;
    }

    :hover {
        color: var(--blue-700);
        border: 1px solid var(--blue-700);

        .ellipsisGallery,
        .btn-default {
            color: var(--blue-700);
        }
    }

    i {
        color: var(--blue-500);
        text-align: center;
        font-size: 11px;
        font-style: normal;
        font-weight: 600;
        line-height: 16px;
        padding-left: 16px;
    }

    .btn-default {
        border: none;
        box-shadow: none;
        padding: 0 0 0 16px;
        color: var(--blue-500);
        background: transparent;
        font-weight: 600;
    }
    .open > .btn-default.dropdown-toggle {
        background: transparent;
        box-shadow: none;
        color: var(--blue-500);
    }

    .ellipsisGallery {
        position: relative;
        right: 16px;
        color: var(--blue-500);
    }

    .dropdown-menu {
        right: -12px;
        margin-top: 6px;
    }
`
